import React from 'react';
import { ServiceRequestSuccessScreen } from '@/modules/support/components/ServiceRequestSuccessScreen';

export default function ServiceRequestSuccess() {
    return <ServiceRequestSuccessScreen />;
}


